import { lazy } from 'react';

import mapTaskLanguages from '@app/features/project/screens/Tasks/pages/NewTask/helpers/mapTaskLanguages';
import type { TaskLanguage } from '@app/features/project/screens/Tasks/pages/NewTask/types';
import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const NewTaskPage = lazy(() => import('.'));

class NewTaskPageWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['project-languages', 'ctsEnabled'];
    }

    render() {
        const projectLanguages = this.jsonProp<TaskLanguage>('project-languages');
        const ctsEnabled = this.jsonProp<boolean>('ctsEnabled');

        const mappedTaskLanguages = mapTaskLanguages(projectLanguages);

        return (
            <RootProviders>
                <NewTaskPage ctsEnabled={ctsEnabled ?? false} taskLanguageList={mappedTaskLanguages} />
            </RootProviders>
        );
    }
}

customElements.define('new-tasks-create', NewTaskPageWebComponent);
